/* eslint-disable react/require-default-props */
import React from 'react';
import MagicWandIcon from '@bufferapp/ui/Icon/Icons/MagicWand';
import RefreshIcon from '@bufferapp/ui/Icon/Icons/Refresh';
import Tag from '@bufferapp/ui/Tag';

import { Button } from '~/ai/styles/Button';

/**
 *
 */
const AIButton = ({
  id,
  label,
  loading,
  disabled,
  isBeta,
  onClick,
  className,
}: {
  id?: string;
  label: string | null;
  loading: boolean;
  disabled?: boolean;
  isBeta: boolean;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <Button id={id} onClick={onClick} disabled={disabled} className={className}>
      {loading ? <RefreshIcon /> : <MagicWandIcon />}
      {label}
      {isBeta && <Tag color="teal">Beta</Tag>}
    </Button>
  );
};

export { AIButton };
